import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";

import PersonIcon from "@mui/icons-material/Person";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

import SignUp from "./SignUp";

import { setUser, showToast } from "../../store/actions";
import AuthService from "../../service/auth";
import Loading from "../Loading";

export default function Login() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state);

  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    if (queryParams.has("message") && queryParams.get("message")) {
      const message = queryParams.get("message");
      dispatch(
        showToast({
          message,
          type: "error",
        })
      );

      queryParams.delete("message");
      navigate("/");
    }
  }, [navigate, dispatch, location.search]);

  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({
    password: false,
  });

  //Check of user is Logged in then redirecting to Dashboard
  useEffect(() => {
    const getAuthUser = async () => {
      const authService = new AuthService();
      const response = await authService.getAuthUser();

      if (response.success) {
        dispatch(setUser(response.data));
        navigate("/dashboard");
      } else {
        dispatch(setUser(null));
      }
    };

    getAuthUser();
    if (user.currentUser) {
      navigate("/dashboard");
    }

    return () => {
      setLoginId("");
      setPassword("");
    };
  }, [user.currentUser, navigate, dispatch]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    setErrors({
      password: password.trim().length < 6 || password.trim().length > 15,
    });

    if (!(password.trim().length < 6 || password.trim().length > 15)) {
      setLoading(true);
      const authService = new AuthService();
      const response = await authService.login(loginId, password, 0);

      if (response.success && response.data) {
        dispatch(setUser(response.data.user));

        navigate("/dashboard");

        setLoginId("");
        setPassword("");
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  };

  if (user.isLoading) return <Loading />;

  return (
    <ThemeProvider theme={theme}>
      <Box
        id="login-page"
        component="main"
        sx={{
          background: (theme) => {
            return theme.palette.TiffanyBlue.gradient;
          },
          flexGrow: 1,
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Container component="main" sx={{ backgroundColor: "#fff", borderRadius: "10px", overflowY: "auto" }}>
          <CssBaseline />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h1 style={{ fontSize: "30px", marginBottom: "10px" }}> Welcome to LogoPromo </h1>
            <span style={{ fontSize: "18px", textAlign: "center" }}> Login to our product sourcing user friendly <br /> client portal & to check our product price lists </span>
          </Box>

          <Grid container direction="row" spacing={3} sx={{ mt: 3 }}>
            <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                style={{ padding: "25px" }}
              >
                <Typography style={{ fontSize: "18px", fontWeight: "bold" }}>Client Login</Typography>

                <TextField
                  margin="normal"
                  autoComplete="username"
                  onChange={(e) => setLoginId(e.target.value)}
                  required
                  fullWidth
                  label="Login ID"
                  autoFocus
                  sx={{ mt: 4 }}
                  InputProps={{
                    endAdornment: <PersonIcon color="primary" />,
                  }}
                />
                <TextField
                  margin="normal"
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  fullWidth
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="password"
                  error={errors.password}
                  helperText={errors.password ? "Password length should be between 6 and 15" : ""}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword((prev) => !prev)}
                        onMouseDown={(e) => e.preventDefault()}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    ),
                  }}
                />
                <Button
                  className="btn btn-primary"
                  color="secondary"
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{ mt: 3, mb: 2 }}
                  disabled={!(loginId && password) || loading}
                >
                  {loading ? <CircularProgress style={{ width: "20px", height: "20px" }} /> : "Login"}
                </Button>
                <Box display={"flex"} justifyContent={"end"} sx={{ mt: 1 }}>
                  <Link
                    style={{
                      fontSize: "15px",
                      textDecoration: "none",
                      color: "#514efd",
                      fontWeight: "bold",
                    }}
                    to="/forgot-password"
                  >
                    Forgot Password?
                  </Link>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} style={{ paddingTop: 0 }}>
              <SignUp />
            </Grid>
          </Grid>

        </Container>
      </Box>
    </ThemeProvider>
  );
}
